
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import React from "react"
import { useTranslation } from "react-i18next"
import moment from "moment"

export const TodaysTotalComplaintExportGridData = (props) => {
    const { ExcelData, name, Language } = props
    const { t } = useTranslation()

    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-TodaysTotalExport"
                className="btn btn-success float-end download-table-xls-button btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'gray' }}
            />

            <table id="table-to-TodaysTotalExport" style={{ display: 'none', width: '100%', border: "1px solid gray" }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ paddingLeft: '50px', textAlign: "center", fontSize: 16 }}>{name}</h4>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid gray" }}>

                        <th className="sr_no_col text-center" style={{ borderLeft: "1px solid white" }}>  {t('EncroachmentDashboard.SrNo')}</th>
                        <th className="text-center">{t('EncroachmentDashboard.UploadDate')}</th>
                        <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                        <th className="text-center">{t('EncroachmentDashboard.WardName')}</th>
                        <th className="text-center">{t('EncroachmentDashboard.AreaName')}</th>
                        <th className="text-center">{t('EncroachmentDashboard.ComplaintUploadDate')}</th>
                        <th className="text-center">{t('EncroachmentDashboard.complaintUploadedOfficername')}</th>
                        <th className="text-center">{t('EncroachmentDashboard.Remark')}</th>
                        <th className="text-center">{t('EncroachmentDashboard.OfficerName')}</th>
                        <th className="text-center">{t('EncroachmentDashboard.UploadedThrough')}</th>

                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.length > 0 ? ExcelData.map((i, index) => {
                            return (
                                <>
                                    <tr style={{ width: '100%', border: "1px solid gray" }} key={index}>
                                        <td style={{ verticalAlign: "middle", textAlign: 'center' }} className="py-1" align="center">{i.rowNum}</td>
                                        <td style={{ verticalAlign: "middle", textAlign: 'center' }} className="nowrap">{i.uploadDate ? moment(i.uploadDate).format("DD-MM-YYYY") : '-'}</td>
                                        <td style={{ verticalAlign: "middle", textAlign: 'center' }} className="nowrap" >{i.zoneName ? i.zoneName : '-'}</td>
                                        <td style={{ verticalAlign: "middle", textAlign: 'center' }} >{i.wardName ? i.wardName : '-'}</td>
                                        <td style={{ verticalAlign: "middle", textAlign: 'center' }} >{i.encroachmentArea ? i.encroachmentArea : '-'}</td>
                                        <td style={{ verticalAlign: "middle", textAlign: 'center' }} className="nowrap">{i.uploadDate ? moment(i.uploadDate).format("DD-MM-YYYY") : '-'}</td>
                                        <td style={{ verticalAlign: "middle", textAlign: 'center' }} >{i.createBy_OfficerName ? i.createBy_OfficerName : '-'}</td>
                                        <td style={{ verticalAlign: "middle", textAlign: 'center' }} >{i.uploadRemark ? i.uploadRemark : '-'}</td>
                                        <td style={{ verticalAlign: "middle", textAlign: 'center' }} >{i.createBy_OfficerName ? i.createBy_OfficerName : '-'}</td>
                                        <td style={{ verticalAlign: "middle", textAlign: 'center' }} > {i.m_Indicator_UploadedThrough ? i.m_Indicator_UploadedThrough : '-'}</td>
                                    </tr>

                                </>
                            )
                        }
                        )
                            : <td colSpan={15}>No data found</td>
                    }
                </tbody>

            </table>
        </div >
    )
}

